module.exports = __webpack_public_path__ + "static/img/1.12dd904.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/2/sp/1.png
// module id = iW6B
// module chunks = 0